var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10039 0.617887L7.71706 6.21789C7.78372 6.28455 7.83084 6.35678 7.85839 6.43455C7.88639 6.51233 7.90039 6.59566 7.90039 6.68455C7.90039 6.77344 7.88639 6.85678 7.85839 6.93455C7.83084 7.01233 7.78372 7.08455 7.71706 7.15122L2.10039 12.7679C1.94484 12.9234 1.75039 13.0012 1.51706 13.0012C1.28372 13.0012 1.08372 12.9179 0.917058 12.7512C0.750391 12.5846 0.667058 12.3901 0.667058 12.1679C0.667058 11.9457 0.750391 11.7512 0.917058 11.5846L5.81706 6.68455L0.917058 1.78455C0.761502 1.629 0.683724 1.43744 0.683724 1.20989C0.683724 0.981887 0.767057 0.784554 0.933724 0.617887C1.10039 0.45122 1.29484 0.367887 1.51706 0.367887C1.73928 0.367887 1.93372 0.45122 2.10039 0.617887Z",
    fill: "#E5CC82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.1f886bc94b521a979ead1e25c1ed9863.svg";
export { ForwardRef as ReactComponent };